import { Avatar } from "antd";
import React, { useState } from "react";
import {
  momentit,
  removeStylesFromHtml,
  replaceContentEditableText,
} from "../../utils";
import { ReactComponent as ViewIcon } from "../../Icons/totalView.svg";
import { ReactComponent as ArrowUpIcon } from "../../Icons/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../Icons/arrowDown.svg";
import TooltipComp from "../ToolTip/TooltipComp";
import { ReactComponent as CheckBoxIcon } from "../../Icons/checkbox.svg";
import { ReactComponent as CheckBoxSelectedIcon } from "../../Icons/check-square.svg";
import { useSelector } from "react-redux";
import ExpertQA from './ExpertQA/index';
import DocQA from './docQA/index';

export default function AnswerBoxForSourceSelection({ question, data, onClickFunc, options}) {
  const [isShow, setShow] = useState(false);
  const searchState = useSelector(state=>state.search);
  const onClickCheckBox=(id, key)=>{
    if(key === 'in'){
      let newArr = [...options];
      newArr.push(id);
      onClickFunc(newArr);
    }
    if(key==='out'){
      let newArr = [...options];
      newArr = newArr.filter((item)=>item!==id);
      onClickFunc(newArr);
    }
  }
  const containerStyle = {
    border: "1px solid #E0E2E6",
    padding: "24px 20px 24px 20px",
    borderRadius: "12px",
    marginBottom: "24px",
    background: "#FFFFFF",
    width: "97%",
  };
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "7px",
  };
  const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "12px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };
  const ansStyles = {
    marginTop: "10px",
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "24px",
    fontWeight: "300",
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  };
  const showMoreStyles = {
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "500",
    background:
      "linear-gradient(90deg, #00D1FF 0%, #BD00FF 15.98%, #0075FF 29.15%, #00E0FF 43.18%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };
  const textStyles2 = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "400",
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
  };
  const trimString = (str) => {
    if (str===null || str === undefined) return;
    if(str.includes('VIZSEP')){
      str = str.replaceAll("VIZSEP", "\n");
    }
    if (str.length > 500) {
      return str.slice(0, 500) + "...";
    }
    return str;
  };
  const userProfile=()=>{
    let img='';
    img = searchState.usersProfilePicData.find(
      (obj) => obj.uuid === data.expertUuid
    );
    if(img !== undefined){
      return `data:image/JPEG;base64,${img.img}`;
    }
  }
  // console.log("trending data",data);
  // console.log("trending question",question)
  return (
    <>
      <div style={{ display: "flex", width: "100%" }}>
        <div
          style={{
            width: "3%",
            display: "flex",
            alignItems: "center",
            marginBottom: "24px",
            marginRight:'2px'
          }}
        >
          {options.includes(data.answerUuid) && <CheckBoxSelectedIcon style={{cursor:'pointer'}} onClick={()=>onClickCheckBox(data.answerUuid,'out')} />}
          {!options.includes(data.answerUuid) && <CheckBoxIcon style={{cursor:'pointer'}} onClick={()=>onClickCheckBox(data.answerUuid, 'in')} />}
        </div>
        <div style={{width:'97%'}}>
          {question.docType==='expertqa' && <ExpertQA data={[data]} question={question} />}
          {question.docType !== 'expertqa' && <DocQA data={data} question={question} />}
        </div>
      </div>
    </>
  );
}
